<template>
  <svg
    aria-hidden="true"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.1423 9.03972C11.362 8.82004 11.7181 8.82004 11.9378 9.03972L17.6727 14.7746C17.8923 14.9943 17.8923 15.3504 17.6727 15.57L17.4075 15.8352C17.1878 16.0549 16.8317 16.0549 16.612 15.8352L11.5401 10.7633L6.46812 15.8352C6.24844 16.0549 5.89234 16.0549 5.67267 15.8352L5.40747 15.57C5.18779 15.3504 5.18779 14.9943 5.40747 14.7746L11.1423 9.03972Z"
      fill="currentColor"
    />
  </svg>
</template>
